import { ManualFindingFlagReason } from '../constants/comment';

export function getFlagReasonTranslationKey(reason: ManualFindingFlagReason): string {
  return `flag_reason_${reason}`;
}

export function taskPushedToIntegrationCommentContent(integrationName: string, userName: string): string {
  return `Task pushed to ${integrationName} by ${userName} from Level Access Platform.`;
}
